import React from "react"
import { useDispatch, useSelector } from "react-redux"

import { toast } from 'react-toastify'

import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

import iconSettings from '../../img/tabla/iconSettings.svg'
import { iniSaveItemsHide } from '../../../../redux/actions/pptos'
import { getItemsSelected } from "../../../../helpers/pptos"

export const ItemsActionsMenu = () => {


    const dispatch = useDispatch()
    const detailBudget = useSelector(state => state.ppto.detail)
    const [anchorEl, setAnchorEl] = React.useState(null)
    const open = Boolean(anchorEl)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleHideItem = async (status) => {
        const itemsSelected = await getItemsSelected(detailBudget.items)

        if (itemsSelected.length === 0) {
            toast.warning('Debes seleccionar al menos un ítem')
            return false
        }

        if (status) {

            let sum = 0
            for (let x = 0; x < itemsSelected.length; x++) {
                sum = sum + parseFloat(itemsSelected[x].precio_subtotal)
            }

            if (sum > 0) {
                toast.warning('No es posible ocultar. Hay ítems con precio de venta')
                return false
            }

        }

        dispatch(iniSaveItemsHide(detailBudget.items, itemsSelected, status))

    }

    return (
        <div>
            <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <div className="d-flex justify-content-center align-items-center" style={{ height: '10px' }}>
                    <img src={iconSettings} alt="acciones ítems" style={{ color: '#78667E' }} />
                    <i className="bi bi-caret-down-fill ms-1" style={{ color: '#78667E' }} />
                </div>
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >

                <MenuItem onClick={() => handleHideItem(true)} className="p-options-items-menu">
                    <i className="bi bi-eye-slash" style={{ color: '#78667E!important' }}></i>
                    <span className="ms-2">Ocultar ítem en pdf</span>
                </MenuItem>

                <MenuItem onClick={() => handleHideItem(false)} className="p-options-items-menu">
                    <i className="bi bi-eye" style={{ color: '#78667E!important' }}></i>
                    <span className="ms-2">Mostrar ítem en pdf</span>
                </MenuItem>
            </Menu>
        </div>
    );
}